import React, { ReactNode } from "react";
import { useTheme } from "../contexts/ThemeContext";
import MobileNav from "./MobileNav";
import Sidebar from "./Sidebar";

interface DashboardLayoutProps {
  children: ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { isDarkMode } = useTheme();

  // NOTE: session-duration milestone timers are intentionally NOT mounted
  // here. DashboardLayout is instantiated fresh inside each authenticated
  // <Route> in App.tsx, so any timers started here would reset on every
  // navigation. The milestone hook is mounted once at App scope via
  // <SessionMilestoneTracker /> so timers span the whole session.

  return (
    <div className={`h-dvh flex flex-col md:flex-row overflow-hidden ${
      isDarkMode 
        ? "bg-black" 
        : "bg-gradient-to-br from-gray-50 to-gray-100"
    }`}>
      <MobileNav />
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden relative">
        <div className="flex-1 overflow-auto">{children}</div>
      </div>
    </div>
  );
};

export default DashboardLayout;
